import { Controller } from "@hotwired/stimulus";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
  static targets = ["number"];

  connect() {
    if (!this.hasNumberTarget) return;

    this.numberTargets.forEach((target) => {
      const targetValue = parseFloat(target.dataset.targetValue);
      const format = target.dataset.format || 'number';
      const hasTilde = target.dataset.hasTilde === 'true';
      const currencySymbol = target.dataset.currencySymbol || '€';
      
      if (isNaN(targetValue)) return;

      const triggerElement = target.closest('.stats-display__item');
      if (!triggerElement) return;

      const startValue = targetValue * 0.85;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: triggerElement,
          start: "top 85%",
          toggleActions: "play none none none"
        }
      });

      const counter = { value: startValue };

      tl.fromTo(target, 
        { opacity: 0 },
        { 
          opacity: 1, 
          duration: 0.3, 
          ease: "power2.out" 
        },
        0
      )
      .to(counter,
        {
          value: targetValue,
          duration: 1.5,
          ease: "power2.out",
          onUpdate: () => {
            target.textContent = this.formatNumber(counter.value, targetValue, format, hasTilde, currencySymbol);
          }
        },
        0
      );
    });
  }

  formatNumber(currentValue, targetValue, format, hasTilde = false, currencySymbol = '€') {
    const value = Math.min(currentValue, targetValue);
    
    switch(format) {
      case 'currency':
        const isWholeNumber = targetValue % 1 === 0;
        const currencyValue = isWholeNumber ? Math.round(value) : value;
        const formattedCurrency = currencyValue.toLocaleString('nl-NL', {
          minimumFractionDigits: isWholeNumber ? 0 : 2,
          maximumFractionDigits: isWholeNumber ? 0 : 2
        });
        return `${currencySymbol} ${formattedCurrency}`;
      case 'percentage':
        const percentageValue = Math.round(value);
        return hasTilde ? `~${percentageValue}%` : `${percentageValue}%`;
      case 'percentage-exact':
        return `${Math.round(value)}%`;
      case 'number':
      default:
        return Math.round(value).toLocaleString('nl-NL');
    }
  }
}

